import request from "@/uilt/new-axios.js";
import serverConfig from "@/assets/global/serverConfig";

export const getTenantDetail = (guid) => {
  return request.get(
    `${serverConfig.msCustomerService}/tenant/data/get-tenant-detail?guid=${guid}`
  );
};
export const getCopyCount = (params) => {
  return request.get(
    `/${serverConfig.msCustomerService}/servicer-copy/get-copy-count`,
    params
  );
};
export const saveCopyData = (data) => {
  return request.postJson(
    `/${serverConfig.msCustomerService}/servicer-copy/save`,
    data
  );
};
export const getCopyProgressPageList = (data) => {
  return request.postJson(
    `/${serverConfig.msCustomerService}/servicer-copy/page-list`,
    data
  );
};

export const getServiceProviderList = (data) => {
  return request.postJson(
    `/${serverConfig.msCustomerService}/tenant-expand/service/get-list`,
    data
  );
};
